import { apiClient } from './client';

export interface Tenant {
  id: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface TenantDocTypeConfig {
  tenantId: string;
  docType: string;
  fields: Array<{
    fieldName: string;
    alias?: string;
    mandatory?: boolean;
  }>;
  updatedAt?: string;
}

export const tenantApi = {
  list: () => apiClient.get<{ data: Tenant[]; count: number }>('/tenants'),

  get: (id: string) => apiClient.get<Tenant>(`/tenants/${id}`),

  create: (data: { id: string; name: string }) =>
    apiClient.post<Tenant>('/tenants', data),

  update: (id: string, data: { name: string }) =>
    apiClient.put<Tenant>(`/tenants/${id}`, data),

  listDocTypes: (tenantId: string) =>
    apiClient.get<{ data: TenantDocTypeConfig[]; count: number }>(
      `/tenants/${tenantId}/doctypes`
    ),

  getDocTypeConfig: (tenantId: string, docType: string) =>
    apiClient.get<TenantDocTypeConfig>(
      `/tenants/${tenantId}/doctype/${docType}`
    ),

  saveDocTypeConfig: (
    tenantId: string,
    docType: string,
    config: { fields: TenantDocTypeConfig['fields'] }
  ) =>
    apiClient.put<TenantDocTypeConfig>(
      `/tenants/${tenantId}/doctype/${docType}`,
      config
    ),
};